import { Injectable } from '@angular/core';
import { DatabaseService } from '../alcance/services/database.service';
import { DatabaseIndice, DatabaseRelation } from '../alcance/interfaces/database';

@Injectable({
  providedIn: 'root'
})
export class EstoqueDBService extends DatabaseService {
    override classname: string = 'EstoqueDBService';
    override table = 'estoque';
    override keyPath = 'estoque';

    override migration = 4;

    override indices: DatabaseIndice[] = [
        { name: "by_id", field: "id", unique: false, multiEntry: false },
        { name: "by_edificacao", field: "almoxarifado.edificacao_id", unique: false, multiEntry: false },
        { name: "by_descricao", field: "descricao", unique: false, multiEntry: false },
        { name: "by_equipamento", field: "equipamento_id", unique: false, multiEntry: false },
        { name: "by_tipo", field: "equipamento.tipo_id", unique: false, multiEntry: false },
        { name: "by_tipos", field: "equipamento.tipos.id", unique: false, multiEntry: true },
        { name: "by_categoria", field: "equipamento.categoria_id", unique: false, multiEntry: false },
        { name: "by_almoxarifado", field: "almoxarifado_id", unique: false, multiEntry: false },
        { name: "by_sinc", field: "sinc", unique: false, multiEntry: false },
    ];

    protected override relations: DatabaseRelation[] = [
        // {name: 'edificacao', table: 'edificacao', field: 'edificacao_id', type: 'foreign'},
        {name: 'equipamento', table: 'equipamento', field: 'equipamento_id', type: 'foreign', key:'equipamento'},
        {name: 'almoxarifado', table: 'almoxarifado', field: 'almoxarifado_id', type: 'foreign', key:'almoxarifado'},
    ];

    protected override filterSql(sql: string, params: any): string {
        if(params?.descricao){
            if(sql.indexOf('WHERE') == -1)
                sql += ' WHERE';
            else
                sql += ' AND';

            const descricao = this.escapeSqlLike(params.descricao);
            sql += " (by_descricao LIKE '%" + descricao + "%' OR by_id = '" + this.escapeSqlValue(params.descricao) + "')";
        }

        if(params?.almoxarifado_id){
            if(sql.indexOf('WHERE') == -1)
                sql += ' WHERE';
            else
                sql += ' AND';

            sql += " by_almoxarifado = '" + params.almoxarifado_id + "'";
        }

        if(params?.tipo_id){
            if(sql.indexOf('WHERE') == -1)
                sql += ' WHERE';
            else
                sql += ' AND';

            const tipoId = params.tipo_id;
            sql += " (by_tipo = '" + tipoId + "' OR EXISTS (SELECT 1 FROM estoque_by_tipos multi_entry WHERE multi_entry.foreign_estoque = estoque.estoque AND multi_entry.by_tipos = '" + tipoId + "'))";
        }

        if(params?.categoria_id){
            if(sql.indexOf('WHERE') == -1)
                sql += ' WHERE';
            else
                sql += ' AND';

            sql += " by_categoria = '" + params.categoria_id + "'";
        }

        if(params?.exceto_equipamento_id){
            if(sql.indexOf('WHERE') == -1)
                sql += ' WHERE';
            else
                sql += ' AND';

            sql += " (by_equipamento IS NULL OR by_equipamento != '" + this.escapeSqlValue(params.exceto_equipamento_id) + "')";
        }

        if(params?.exceto_estoque_ids){
            const ids = (Array.isArray(params.exceto_estoque_ids) ? params.exceto_estoque_ids : params.exceto_estoque_ids.toString().split(','))
                .map((id: any) => Number(id))
                .filter((id: number) => !isNaN(id) && id > 0);

            if(ids.length){
                if(sql.indexOf('WHERE') == -1)
                    sql += ' WHERE';
                else
                    sql += ' AND';

                sql += " by_id NOT IN (" + ids.join(',') + ")";
            }
        }

        return sql;
    }

    private escapeSqlLike(value: any): string {
        return this.escapeSqlValue(value).replace(/[%_]/g, (char) => '\\' + char);
    }

    private escapeSqlValue(value: any): string {
        return (value === undefined || value === null ? '' : value.toString()).replace(/'/g, "''");
    }
}
